import React from 'react';

export const TrackItTopBarNew = (abyssHeaderStyle) => {
  return (
    //TODO
    <abyss-parcel import='trackit-top-bar@dev' />
  );
};
